module.exports = __webpack_public_path__ + "media/images/emblems/Greifensee-blazon-8cb8123a6359800762459f74e26075fd.svg";